import envConfig from '@ers/config/env';

const config = {
    authorization: {
        authority: '',
        post_logout_redirect_uri: '',
        post_account_delete_redirect_uri: '',
        ...envConfig.authorization
    },
    urls: {
        ...envConfig.urls
    },
    sentry: {
        ...envConfig.sentry
    },
    microsoftInsights: {
        ...envConfig.microsoftInsights
    }
};
export default config;
